import domReady from '@wordpress/dom-ready';

domReady(() => {
  const courseGridBlocks = document.querySelectorAll('.course-grid-section');

  courseGridBlocks.forEach((block) => {
    // Course items expansion
    const items = block.querySelectorAll('.course-grid-course__item');

    items.forEach((item) => {
      item.addEventListener('click', function () {
        const content = document.getElementById(
          this.getAttribute('aria-controls')
        );
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const icon = this.querySelector('.icon');

        this.setAttribute('aria-expanded', !isExpanded);

        if (isExpanded) {
          content.classList.remove('active');
          icon.classList.remove('rotate');
        } else {
          content.classList.add('active');
          icon.classList.add('rotate');
        }
      });

      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          item.click();
        }
      });
    });

    // Semester tabs
    const semestertabs = block.querySelectorAll(
      '.course-grid-semester-tabs span'
    );
    const semesterPanes = block.querySelectorAll(
      '.course-grid-semester-tabs-pane'
    );

    semestertabs.forEach((tabTitle) => {
      tabTitle.addEventListener('click', () => {
        const targetTab = tabTitle.getAttribute('data-tab');
        semestertabs.forEach((title) => title.classList.remove('active'));
        tabTitle.classList.add('active');
        semesterPanes.forEach((pane) => {
          if (pane.getAttribute('data-tab') === targetTab) {
            pane.classList.add('active');
          } else {
            pane.classList.remove('active');
          }
        });
      });
    });

    // Activer le premier onglet par défaut
    if (semestertabs.length > 0) {
      semestertabs[0].click();
    }

    // Campus item keyboard navigation
    block
      .querySelectorAll('.course-grid-campus_item_number')
      .forEach((item) => {
        item.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            item.click();
          }
        });
      });
  });
});
